import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'codeDesignation'
})
export class CodeDesignationPipe implements PipeTransform {

	transform(value: any, args?: any): string {
		if (value) {
			const code = value.code ? value.code.toUpperCase() : undefined;
			const designation = value.designation ? value.designation : undefined;
			return (code && designation) ? `${code} - ${designation}` : code || designation || '';
		}
		return '';
	}

}
